export enum CAR_OWNER {
  Individual = 'Individual',
  Company = 'Company',
}
export const CarOwnerTitleMap = {
  [CAR_OWNER.Individual]: 'Individual',
  [CAR_OWNER.Company]: 'Company',
};
export const CarOwnerTypes = [
  {
    name: CarOwnerTitleMap[CAR_OWNER.Individual],
    value: CAR_OWNER.Individual,
  },
  { name: CarOwnerTitleMap[CAR_OWNER.Company], value: CAR_OWNER.Company },
];
export enum MARITAL_STATUS {
  Single = 'Single',
  Married = 'Married',
}
export enum KYC_IMAGE_TYPE {
  AADHAR_FRONT = 'AADHAR_FRONT',
  AADHAR_BACK = 'AADHAR_BACK',
  PROFILE_IMG = 'PROFILE_IMG',
}
export enum SEARCH_TYPE {
  Rto = 'Rto',
  StateCity = 'StateCity',
}
export const MaritalStatusTitleMap = {
  [MARITAL_STATUS.Single]: 'Single',
  [MARITAL_STATUS.Married]: 'Married',
};
export const MaritalStatusTypes = [
  {
    name: MaritalStatusTitleMap[MARITAL_STATUS.Single],
    value: MARITAL_STATUS.Single,
  },
  {
    name: MaritalStatusTitleMap[MARITAL_STATUS.Married],
    value: MARITAL_STATUS.Married,
  },
];
export enum GENDER {
  Male = 'Male',
  Female = 'Female',
}
export const GenderTitleMap = {
  [GENDER.Male]: 'Male',
  [GENDER.Female]: 'Female',
};
export const GenderTypes = [
  { name: GenderTitleMap[GENDER.Male], value: GENDER.Male },
  { name: GenderTitleMap[GENDER.Female], value: GENDER.Female },
];
export enum TRANSMISSION {
  Manual = 'Manual',
  Automatic = 'Automatic',
}
export const TransmissionTitleMap = {
  [TRANSMISSION.Manual]: 'Manual',
  [TRANSMISSION.Automatic]: 'Automatic',
};
export const TransmissionTypes = [
  {
    name: TransmissionTitleMap[TRANSMISSION.Manual],
    value: TRANSMISSION.Manual,
  },
  {
    name: TransmissionTitleMap[TRANSMISSION.Automatic],
    value: TRANSMISSION.Automatic,
  },
];
export enum POLICY_TYPES {
  Comprehensive = 'COMPREHENSIVE',
  ThirdParty = 'THIRD_PARTY',
  OwnDamage = 'OWN_DAMAGE',
}

export const PolicyTypeTitleMap = {
  [POLICY_TYPES.Comprehensive]: 'Comprehensive',
  [POLICY_TYPES.ThirdParty]: 'Third Party',
  [POLICY_TYPES.OwnDamage]: 'Own Damage',
  PAY_AS_YOU_DRIVE: 'Pay As You Drive',
};
export const PolicyTypes = [
  {
    name: PolicyTypeTitleMap[POLICY_TYPES.Comprehensive],
    value: POLICY_TYPES.Comprehensive,
  },
  {
    name: PolicyTypeTitleMap[POLICY_TYPES.ThirdParty],
    value: POLICY_TYPES.ThirdParty,
  },
  {
    name: PolicyTypeTitleMap[POLICY_TYPES.OwnDamage],
    value: POLICY_TYPES.OwnDamage,
  },
];

export enum BREAKIN_STATUS {
  APPROVED = 'inspection_approved',
  PENDING = 'inspection_pending',
  REJECTED = 'inspection_rejected',
}

export enum RESUME_JOURNEY {
  QUOTE = 'QUOTE',
  BEFORE_PAYMENT = 'BEFORE_PAYMENT',
  AFTER_PAYMENT = 'AFTER_PAYMENT',
}
export enum KYC_STEPS {
  PAN = 'INITIATE_PAN',
  AADHAR = 'INITIATE_AADHAR',
  OVD = 'INITIATE_OVD',
  DOWNLOAD_POLICY = 'DOWNLOAD_POLICY',
  INITIATE_KYC_FAILED = 'INITIATE_KYC_FAILED',
  HALT_SCREEN = 'HALT_SCREEN',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  OPEN_FORM_AFTER_PAYMENT = 'OPEN_FORM_AFTER_PAYMENT',
}
export enum KYC_STATUS {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  COMPLETE_FAILED = 'COMPLETE_FAILED',
}
export enum FILTER_POPUPS {
  NCB = 'NCB',
  IDVCover = 'IDV',
  FILTER = 'FILTER',
  OD_ExpiryDate = 'OD_EXPIRY_DATE',
  TP_ExpiryDate = 'TP_EXPIRY_DATE',
}

export enum TabBarEnums {
  Recommended,
  PayAsYouDrive,
}

export enum AddVehicleSource {
  existingCar = 'existing-car',
  manualExistingCar = 'existing-manual-car',
  newCar = 'new-car',
}

export enum NewVehicleSteps {
  MMV = 'MMV',
  RTO = 'RTO',
  RegDate = 'REG_DATE',
}

export const NCBTableData = [
  {
    point1: 'No claim in last 1 years',
    point2: 'Select 0%',
  },
  {
    point1: 'No claim in last 2 years',
    point2: 'Select 20%',
  },
  {
    point1: 'No claim in last 3 years',
    point2: 'Select 25%',
  },
  {
    point1: 'No claim in last 4 years',
    point2: 'Select 35%',
  },
  {
    point1: 'No claim in last 5 years',
    point2: 'Select 45%',
  },
  {
    point1: 'No claim in last 6 or more years',
    point2: 'Select 50%',
  },
];
export const NCBPercentChips = [
  {
    display: '0%',
    value: 0,
  },
  {
    display: '20%',
    value: 20,
  },
  {
    display: '25%',
    value: 25,
  },
  {
    display: '35%',
    value: 35,
  },
  {
    display: '45%',
    value: 45,
  },
  {
    display: '50%',
    value: 50,
  },
];
export const EXPIRY_OPTIONS = [
  { label: 'Policy has not expired yet', value: 7 },
  { label: 'Policy expired within last 60 days', value: -30 },
  { label: 'Policy expired within 60-90 days', value: -60 },
  { label: 'Policy expired more than 90 days ago', value: -90 },
  { label: 'I have bought a used car', value: 1 },
];
export const EXPECTED_DELIVERY_DATE = [
  { label: 'Today or tomorrow', value: 1 },
  // { label: 'In the next 7 days', value: 6 },
  // { label: 'Within next 15 days', value: 14 },
  // { label: 'Within next 30 days', value: 29 },
  { label: 'I don’t know my car’s delivery date', value: 0 },
];

export const VEHICLE_IMAGE_FALLBACK =
  'https://parkplus-bkt-img.parkplus.io/production/fuel-bill/public/Banner013_20230727191745795308.png';

export const PageName = {
  INSURANCE_HOMEPAGE: 'insurance_homepage',
  INSURANCE_CHECK_CAR_PAGE: 'insurance_check_car_page',
  VEHICLE_BRAND_PAGE: 'vehichle_brand',
  VEHICLE_MODAL_PAGE: 'vehicle_model',
  VEHICLE_VARIANT_PAGE: 'vehicle_variant',
  VEHICLE_RTO_PAGE: 'vehicle_rto',
  INSURANCE_FILL_DETAIL_PAGE: 'insurance_fill_detail_page',
  INSURANCE_PLAN_DISPLAY_PAGE: 'insurance_plan_display_page',
  INSURANCE_PLAN_NOT_AVAILABLE_PAGE: 'insurance_plan_not_available',
  INSURANCE_PLAN_SUMMARY_PAGE: 'insurance_plan_summary_page',
  INSURANCE_PAYMENT_SUCCESS_PAGE: 'insurance_payment_success_page',
  INSURANCE_CURRENT_POLICY_DETAIL_PAGE: 'insurance_current_policy_detail_page',
  INSURANCE_KYC_PAGE: 'insurance_kyc_page',
  INSURANCE_ORDER_DETAIL_PAGE: 'insurance_order_detail_page',
  INSURANCE_INSPECTION_PAGE: 'Inspection_page_guidance',
};

export const INSURANCE_DOCS_URLS = {
  pp: 'https://parkplus-bkt-img.parkplus.io/production/insurance/public/pp_20250328151443191583_cc677221-dbb6-4575-81e5-c0ae9484026d.pdf',
  gv: 'https://parkplus-bkt-img.parkplus.io/production/insurance/public/gv_20250328151403615756_b993e66a-82b9-4ab6-9553-34b51fb1c00a.pdf',
  tc: 'https://parkplus-bkt-img.parkplus.io/production/insurance/public/tc_20250328151511780667_7d4cc790-e36d-4d10-9905-5d164ad0dfdd.pdf',
};
